import {
  INVOICE_LIST,
  INVOICE_DETAIL,
  EXPORT_INVOICE,
  DO_PAYMENT,
  INVOICE_GET_SCHEMA
} from './types';

const BACKEND_API = 'BACKEND_API';

export const fetchInvoices = isNetSuite => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_invoice/?${isNetSuite ? 'include_net_suite=true' : ''}`,
    ...INVOICE_LIST
  }
});

export const fetchInvoiceDetail = id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_invoice/${id}`,
    ...INVOICE_DETAIL
  }
});

export const exportInvoice = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    data,
    url: `/portal_invoice/${id}/export_invoice/`,
    ...EXPORT_INVOICE
  }
});

export const doPayment = (id, data) => ({
  type: BACKEND_API,
  payload:
    {
      method: 'put',
      url: `/portal_invoice/${id}/payment/`,
      data,
      ...DO_PAYMENT
    }
});

export const invoiceGetSchema = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/portal_invoice/get_schema/',
    ...INVOICE_GET_SCHEMA
  }
});
